import types from 'redux/types';

const getNotification = (data) => {
  return {
    ...data,
    type: types.REQUEST_GET_NOTIFICATION,
  };
};

const updateNotification = (params) => {
  return {
    ...params,
    type: types.REQUEST_UPDATE_NOTIFICATION,
  };
};

const countNotificationSuccess = (params) => {
  return {
    ...params,
    type: types.REQUEST_COUNT_NOTIFICATION_SUCCESS,
  };
};

const countNotificationFailed = (params) => {
  return {
    ...params,
    type: types.REQUEST_COUNT_NOTIFICATION_FAILED,
  };
};

const loadMoreNotification = (params) => {
  return {
    ...params,
    type: types.REQUEST_LOAD_MORE_NOTIFICATION,
  };
};

const refetchNotification = (params) => {
  return {
    ...params,
    type: types.REQUEST_RE_FETCH_NOTIFICATION,
  };
};

const markAllAsRead = (params) => {
  return {
    ...params,
    type: types.REQUEST_MARK_AS_ALL_READ,
  };
};

export default {
  markAllAsRead,
  refetchNotification,
  loadMoreNotification,
  countNotificationSuccess,
  countNotificationFailed,

  getNotification,
  updateNotification,
};
